export { default as AlumnosProfesorGrid } from './Listar';
export { default as FormsAlumnosGrid } from './Detalle';
export { default as AsignarFormAlumno } from './AsignarForm';
